module.exports = __webpack_public_path__ + "static/media/android_download.826846b7.png";